(function () {
  'use strict';
  if (window.OAProductGallery) { window.OAProductGallery.boot(document); return; }
  var marker = '[data-oa-native-gallery]', key = '_oaProductGallery';
  function listen(list, node, type, fn, options) {
    if (!node) return;
    node.addEventListener(type, fn, options);
    list.push(function () { node.removeEventListener(type, fn, options); });
  }
  function clear(list) { list.splice(0).forEach(function (off) { off(); }); }
  function Gallery(el) {
    this.el = el;
    this.root = el.closest('[data-product-images]') || el.parentNode;
    this.slides = Array.prototype.slice.call(el.querySelectorAll('.product-main-slide'));
    this.slideStyles = this.slides.map(function (slide) { return slide.getAttribute('style'); });
    this.dots = Array.prototype.slice.call(this.root.querySelectorAll('[data-oa-gallery-index]'));
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-product-thumb]'));
    this.arrows = Array.prototype.slice.call(this.root.querySelectorAll('.product__thumb-arrow'));
    this.listeners = [];
    this.nativeListeners = [];
    this.args = {};
    this.desktop = null;
    this.destroyed = false;
    this.draggable = true;
    this.selectedIndex = Math.max(0, this.slides.indexOf(el.querySelector('.starting-slide')));
    this.currentSlide = this.slides[this.selectedIndex];
    this.viewportWidth = window.innerWidth;
    this.mql = window.matchMedia('(max-width: 768px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.native = this.mql.matches && document.documentElement.dir !== 'rtl';
    this.bindControls();
    var self = this;
    this.breakpoint = function () { self.switchMode(); };
    if (this.mql.addEventListener) listen(this.listeners, this.mql, 'change', this.breakpoint);
    else {
      this.mql.addListener(this.breakpoint);
      this.listeners.push(function () { self.mql.removeListener(self.breakpoint); });
    }
    listen(this.listeners, window, 'resize', function () {
      var width = window.innerWidth;
      if (self.native && width === self.viewportWidth) return;
      self.viewportWidth = width;
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () { self.resize(); }, 120);
    });
    if (this.native) this.enableNative();
    this.select(this.selectedIndex, false);
    el[key] = this;
  }
  Gallery.prototype.resolve = function (value) {
    var id = String(value);
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === id) return i;
    }
    var index = parseInt(value, 10) || 0;
    return (index % this.slides.length + this.slides.length) % this.slides.length;
  };
  Gallery.prototype.select = function (index, notify) {
    var changed = index !== this.selectedIndex;
    this.selectedIndex = index;
    this.currentSlide = this.slides[index];
    this.slides.forEach(function (slide, i) {
      slide.classList.toggle('is-selected', i === index);
      slide.setAttribute('tabindex', i === index ? '0' : '-1');
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    this.dots.forEach(function (dot) {
      var active = Number(dot.getAttribute('data-oa-gallery-index')) === index;
      dot.classList.toggle('is-selected', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    this.thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    this.arrows.forEach(function (arrow) {
      var prev = arrow.classList.contains('product__thumb-arrow--prev');
      arrow.classList.toggle('hide', prev ? index === 0 : index === this.slides.length - 1);
    }, this);
    if (notify && changed) {
      var cb = this.args.callbacks;
      if (cb && cb.onChange) cb.onChange(index);
      this.revealThumb();
    }
  };
  Gallery.prototype.revealThumb = function () {
    var thumb = this.thumbs[this.selectedIndex], scroller = this.args.childNavScroller;
    if (this.native || !thumb || !scroller) return;
    if (this.args.childVertical) scroller.scrollTop = thumb.parentNode.offsetTop - 100;
    else scroller.scrollLeft = thumb.parentNode.offsetLeft - 100;
  };
  Gallery.prototype.bindControls = function () {
    var self = this;
    this.dots.forEach(function (dot) {
      listen(self.listeners, dot, 'click', function (event) {
        event.preventDefault();
        self.goToSlide(dot.getAttribute('data-oa-gallery-index'));
      });
    });
    this.thumbs.forEach(function (thumb) {
      function navigate() { self.goToSlide(thumb.getAttribute('data-id') || thumb.getAttribute('data-index')); }
      listen(self.listeners, thumb, 'click', function (event) { event.preventDefault(); navigate(); });
      listen(self.listeners, thumb, 'focus', navigate);
    });
    this.arrows.forEach(function (arrow) {
      listen(self.listeners, arrow, 'click', function (event) {
        event.preventDefault();
        self.goToSlide(self.selectedIndex + (arrow.classList.contains('product__thumb-arrow--prev') ? -1 : 1));
      });
    });
  };
  Gallery.prototype.enableNative = function () {
    var self = this, el = this.el;
    el.classList.add('oa-native-gallery-active');
    el.setAttribute('tabindex', '0');
    listen(this.nativeListeners, el, 'scroll', function () {
      if (self.pointer) self.pointer.moved = true;
      if (!self.pending && !self.scrollFrame) {
        self.scrollFrame = requestAnimationFrame(function () {
          self.scrollFrame = 0;
          if (self.destroyed || !self.native || self.pending) return;
          self.select(self.nearest(), true);
        });
      }
      clearTimeout(self.settleTimer);
      self.settleTimer = setTimeout(function () {
        self.settleTimer = 0;
        if (self.destroyed || !self.native) return;
        self.pending = false;
        self.select(self.nearest(), true);
      }, 140);
    }, { passive: true });
    listen(this.nativeListeners, el, 'pointerdown', function (event) {
      self.pending = false;
      self.suppressClickUntil = 0;
      self.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
    }, { passive: true });
    listen(this.nativeListeners, el, 'pointermove', function (event) {
      var point = self.pointer;
      if (point && point.id === event.pointerId && Math.abs(event.clientX - point.x) + Math.abs(event.clientY - point.y) > 10) point.moved = true;
    }, { passive: true });
    function endPointer(event) {
      if (!self.pointer || self.pointer.id !== event.pointerId) return;
      if (self.pointer.moved) self.suppressClickUntil = Date.now() + 500;
      self.pointer = null;
    }
    listen(this.nativeListeners, window, 'pointerup', endPointer, { passive: true });
    listen(this.nativeListeners, window, 'pointercancel', endPointer, { passive: true });
    listen(this.nativeListeners, el, 'wheel', function () { self.pending = false; }, { passive: true });
    listen(this.nativeListeners, el, 'click', function (event) {
      if (event.detail !== 0 && Date.now() < (self.suppressClickUntil || 0)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      var slide = event.target.closest('.product-main-slide');
      var index = self.slides.indexOf(slide);
      if (index >= 0 && index !== self.selectedIndex) self.goToSlide(index);
    }, true);
    listen(this.nativeListeners, el, 'keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || /^(INPUT|TEXTAREA|SELECT)$/.test(event.target.tagName)) return;
      var index = self.selectedIndex;
      if (event.key === 'ArrowRight') index++;
      else if (event.key === 'ArrowLeft') index--;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = self.slides.length - 1;
      else return;
      event.preventDefault();
      self.goToSlide(index);
    });
  };
  Gallery.prototype.nearest = function () {
    var track = this.el.getBoundingClientRect(), center = track.left + track.width / 2;
    var best = this.selectedIndex, distance = Infinity;
    this.slides.forEach(function (slide, index) {
      var rect = slide.getBoundingClientRect(), delta = Math.abs(rect.left + rect.width / 2 - center);
      if (delta < distance) { distance = delta; best = index; }
    });
    return best;
  };
  Gallery.prototype.align = function (smooth) {
    if (!this.native || this.destroyed || !this.currentSlide) return;
    cancelAnimationFrame(this.scrollFrame || 0);
    clearTimeout(this.settleTimer);
    this.scrollFrame = 0;
    this.settleTimer = 0;
    var track = this.el.getBoundingClientRect(), slide = this.currentSlide.getBoundingClientRect();
    var left = this.el.scrollLeft + slide.left + slide.width / 2 - track.left - track.width / 2;
    this.pending = true;
    this.el.scrollTo({ left: left, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
  };
  Gallery.prototype.goToSlide = function (value) {
    if (this.destroyed) return;
    var index = this.resolve(value);
    if (this.desktop) { this.desktop.goToSlide(index); return; }
    this.select(index, true);
    this.align(true);
  };
  Gallery.prototype.attach = function (args, DesktopCtor) {
    if (this.destroyed) return this;
    this.args = args || {};
    this.DesktopCtor = DesktopCtor;
    if (!this.native && !this.desktop) this.enableDesktop();
    var self = this;
    Promise.resolve().then(function () {
      if (self.destroyed) return;
      var cb = self.args.callbacks;
      if (cb && cb.onInit) cb.onInit(self.currentSlide);
      if (cb && cb.onChange && Number(self.args.initialIndex || 0) !== self.selectedIndex) cb.onChange(self.selectedIndex);
    });
    return this;
  };
  Gallery.prototype.enableDesktop = function () {
    if (!this.DesktopCtor || this.desktop) return;
    var self = this;
    var args = Object.assign({}, this.args, {
      initialIndex: this.selectedIndex, childNav: null, childNavScroller: null, avoidReflow: false,
      callbacks: { onChange: function (index) { self.select(index, true); } }
    });
    var previousResize = window.namespaces && window.namespaces.resize;
    this.desktop = new this.DesktopCtor(this.el, args);
    var addedResize = window.namespaces && window.namespaces.resize;
    if (addedResize && addedResize !== previousResize) {
      window.removeEventListener('resize', addedResize);
      if (previousResize) window.namespaces.resize = previousResize;
      else delete window.namespaces.resize;
    }
    this.select(this.selectedIndex, false);
    this.desktop.setDraggable(this.draggable);
  };
  Gallery.prototype.stopNative = function () {
    clear(this.nativeListeners);
    clearTimeout(this.settleTimer);
    cancelAnimationFrame(this.scrollFrame || 0);
    this.scrollFrame = 0;
    this.pending = false;
    this.pointer = null;
    this.el.classList.remove('oa-native-gallery-active');
    this.el.removeAttribute('data-oa-drag-disabled');
    this.el.removeAttribute('tabindex');
  };
  Gallery.prototype.destroyDesktop = function () {
    if (!this.desktop) return;
    var retired = this.desktop.slideshow;
    if (retired) {
      retired.isAnimating = false;
      retired.animate = function () {};
    }
    try { this.desktop.destroy(); }
    finally {
      this.desktop = null;
      this.slides.forEach(function (slide, index) {
        var style = this.slideStyles[index];
        if (style === null) slide.removeAttribute('style');
        else slide.setAttribute('style', style);
      }, this);
    }
  };
  Gallery.prototype.switchMode = function () {
    if (this.destroyed) return;
    var native = this.mql.matches && document.documentElement.dir !== 'rtl';
    if (native === this.native) return;
    if (this.native) this.stopNative();
    this.destroyDesktop();
    this.native = native;
    if (native) {
      this.enableNative();
      this.select(this.selectedIndex, false);
      this.setDraggable(this.draggable);
      this.align(false);
    } else {
      this.el.scrollLeft = 0;
      this.enableDesktop();
    }
  };
  Gallery.prototype.resize = function () {
    if (this.destroyed) return;
    if (this.desktop) this.desktop.resize();
    else if (this.native) this.align(false);
  };
  Gallery.prototype.reposition = function () {
    if (this.desktop) this.desktop.reposition();
    else this.resize();
  };
  Gallery.prototype.setDraggable = function (enabled) {
    this.draggable = !!enabled;
    if (this.desktop) this.desktop.setDraggable(this.draggable);
    else if (this.draggable) this.el.removeAttribute('data-oa-drag-disabled');
    else this.el.setAttribute('data-oa-drag-disabled', 'true');
  };
  Gallery.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    clear(this.listeners);
    this.stopNative();
    clearTimeout(this.resizeTimer);
    this.destroyDesktop();
    this.slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); });
    if (this.el[key] === this) delete this.el[key];
  };
  function boot(scope) {
    if (document.documentElement.dir === 'rtl') return;
    var els = Array.prototype.slice.call((scope || document).querySelectorAll(marker));
    if (scope && scope.matches && scope.matches(marker)) els.unshift(scope);
    els.forEach(function (el) { if (!el[key]) new Gallery(el); });
  }
  window.OAProductGallery = {
    boot: boot,
    create: function (el, args, DesktopCtor) {
      if (!el.matches(marker) || document.documentElement.dir === 'rtl') return new DesktopCtor(el, args);
      return (el[key] || new Gallery(el)).attach(args, DesktopCtor);
    }
  };
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (scope.matches && scope.matches(marker) && scope[key]) scope[key].destroy();
    scope.querySelectorAll(marker).forEach(function (el) { if (el[key]) el[key].destroy(); });
  });
  boot(document);
}());
